export { default as configDeterminator } from './configDeterminator';
export { default as oktaConfig } from './oktaConfig';
export { default as widgetConfig } from './widgetConfig';
